import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbd062f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lblTitle" }, "Master Maintenance")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "search-div" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Distributor Code :  ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "no-data"
}
const _hoisted_10 = {
  key: 1,
  class: "searched-dist-cd"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label-title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "SMC confirmer")
], -1 /* HOISTED */))
const _hoisted_13 = { class: "label-Display" }
const _hoisted_14 = { class: "btn-width" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label-title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Approver")
], -1 /* HOISTED */))
const _hoisted_16 = { class: "label-Display" }
const _hoisted_17 = { class: "btn-width" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer1 at Distributor", -1 /* HOISTED */))
const _hoisted_19 = { class: "label-Display-confirmer" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, ": ", -1 /* HOISTED */))
const _hoisted_21 = { class: "confirmer-line" }
const _hoisted_22 = { class: "btn-width" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer2 at Distributor", -1 /* HOISTED */))
const _hoisted_25 = { class: "label-Display-confirmer" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, ": ", -1 /* HOISTED */))
const _hoisted_27 = { class: "confirmer-line" }
const _hoisted_28 = { class: "btn-width" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer3 at Distributor", -1 /* HOISTED */))
const _hoisted_32 = { class: "label-Display-confirmer" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, ": ", -1 /* HOISTED */))
const _hoisted_34 = { class: "confirmer-line" }
const _hoisted_35 = { class: "btn-width" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer4 at Distributor", -1 /* HOISTED */))
const _hoisted_39 = { class: "label-Display-confirmer" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, ": ", -1 /* HOISTED */))
const _hoisted_41 = { class: "confirmer-line" }
const _hoisted_42 = { class: "btn-width" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Confirmer5 at Distributor", -1 /* HOISTED */))
const _hoisted_46 = { class: "label-Display-confirmer" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, ": ", -1 /* HOISTED */))
const _hoisted_48 = { class: "confirmer-line" }
const _hoisted_49 = { class: "btn-width" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "confirmer-top" }, "Approver at Distributor", -1 /* HOISTED */))
const _hoisted_53 = { class: "label-Display-confirmer" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirmer-top" }, ": ", -1 /* HOISTED */))
const _hoisted_55 = { class: "confirmer-line" }
const _hoisted_56 = { class: "btn-width" }
const _hoisted_57 = { colspan: "4" }
const _hoisted_58 = { class: "footer-btn-td" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_62 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = { class: "modal-header" }
const _hoisted_65 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_66 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left"}
}
const _hoisted_67 = { class: "row-div" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "User ID", -1 /* HOISTED */))
const _hoisted_69 = {
  id: "tbldiv",
  class: "tbl-div"
}
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<div class=\"tblTitle-div\" style=\"width:calc(100% - 16px);\" data-v-fbd062f4><table id=\"tblIssueSalesNote\" class=\"w-100\" data-v-fbd062f4><tr data-v-fbd062f4><td style=\"width:4%;\" data-v-fbd062f4></td><th style=\"width:28%;\" data-v-fbd062f4>User ID</th><th style=\"width:40%;\" data-v-fbd062f4>Name</th><th style=\"width:28%;\" data-v-fbd062f4>Station CD</th></tr></table></div>", 1)
const _hoisted_71 = {
  id: "tblbodydiv",
  class: "tblbody-div"
}
const _hoisted_72 = {
  id: "tblIssueSalesNoteDetail",
  class: "w-100"
}
const _hoisted_73 = { id: "tbltbody" }
const _hoisted_74 = { style: {"width":"4%"} }
const _hoisted_75 = ["value", "onChange"]
const _hoisted_76 = { style: {"width":"28%","text-align":"left"} }
const _hoisted_77 = { style: {"width":"40%"} }
const _hoisted_78 = { style: {"width":"28%"} }
const _hoisted_79 = { class: "modal-footer" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  id: "hidbtn",
  name: "hidbtn",
  value: "S"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    ($setup.isLoading)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["SalesNoteHeaderNavigation"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["SalesNoteLinkNavigation"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          maxlength: "6",
          id: "txtDistCd",
          class: "input-field",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.txtDistCd) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.txtDistCd]
        ]),
        _hoisted_6,
        _createElementVNode("button", {
          type: "button",
          "data-bs-toggle": "modal",
          "data-bs-target": "#detailModal",
          class: "btn btn-primary text-center btnSearch",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.btnSearch()))
        }, "Search")
      ]),
      _hoisted_7,
      ($setup.showDetailFlg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                ($setup.noDataFlag === 'NoDataShow')
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_9, "This distributor code does not exist in the master table."))
                  : _createCommentVNode("v-if", true),
                ($setup.noDataFlag === 'DataShow')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_10, " Confirmation and approving route setting for Distributor code : " + _toDisplayString($setup.searchedDistCd), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              ($setup.noDataFlag === 'DataShow')
                ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_12,
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("label", null, ": " + _toDisplayString($setup.smcConfirmer), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "ChangeA",
                            name: "Change",
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showModal('CONFIRMER')))
                          }, "Change")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "ClearC",
                            name: "ClearC",
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.btnClear('CONFIRMER')))
                          }, "Clear")
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_15,
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("label", null, ": " + _toDisplayString($setup.approver), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "ChangeA",
                            name: "Change",
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showModal('APPROVER')))
                          }, "Change")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Clear",
                            name: "Clear",
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.btnClear('APPROVER')))
                          }, "Clear")
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_18,
                        _createElementVNode("td", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("span", _hoisted_21, _toDisplayString($setup.distributorConfirmer1), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Change1",
                            name: "Change1",
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showModal('CONFIRMER1')))
                          }, "Change")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Clear1",
                            name: "Clear1",
                            disabled: $setup.clear1DisableFlag,
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.btnClear('CONFIRMER1')))
                          }, "Clear", 8 /* PROPS */, _hoisted_23)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_24,
                        _createElementVNode("td", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("span", _hoisted_27, _toDisplayString($setup.distributorConfirmer2), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Change1",
                            name: "Change1",
                            disabled: $setup.change2DisableFlag,
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showModal('CONFIRMER2')))
                          }, "Change", 8 /* PROPS */, _hoisted_29)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Clear2",
                            name: "Clear2",
                            disabled: $setup.clear2DisableFlag,
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.btnClear('CONFIRMER2')))
                          }, "Clear", 8 /* PROPS */, _hoisted_30)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_31,
                        _createElementVNode("td", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("span", _hoisted_34, _toDisplayString($setup.distributorConfirmer3), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Change1",
                            name: "Change1",
                            disabled: $setup.change3DisableFlag,
                            class: "btn btn-primary add text-center btnChange",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showModal('CONFIRMER3')))
                          }, "Change", 8 /* PROPS */, _hoisted_36)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Clear3",
                            name: "Clear3",
                            disabled: $setup.clear3DisableFlag,
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.btnClear('CONFIRMER3')))
                          }, "Clear", 8 /* PROPS */, _hoisted_37)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_38,
                        _createElementVNode("td", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("span", _hoisted_41, _toDisplayString($setup.distributorConfirmer4), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_42, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Change1",
                            name: "Change1",
                            disabled: $setup.change4DisableFlag,
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.showModal('CONFIRMER4')))
                          }, "Change", 8 /* PROPS */, _hoisted_43)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Clear4",
                            name: "Clear4",
                            disabled: $setup.clear4DisableFlag,
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.btnClear('CONFIRMER4')))
                          }, "Clear", 8 /* PROPS */, _hoisted_44)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_45,
                        _createElementVNode("td", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("span", _hoisted_48, _toDisplayString($setup.distributorConfirmer5), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_49, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Change1",
                            name: "Change1",
                            disabled: $setup.change5DisableFlag,
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.showModal('CONFIRMER5')))
                          }, "Change", 8 /* PROPS */, _hoisted_50)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "Clear5",
                            name: "Clear5",
                            disabled: $setup.clear5DisableFlag,
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.btnClear('CONFIRMER5')))
                          }, "Clear", 8 /* PROPS */, _hoisted_51)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_52,
                        _createElementVNode("td", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("span", _hoisted_55, _toDisplayString($setup.distributorApprover), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_56, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "ChangeD",
                            name: "ChangeD",
                            class: "btn btn-primary add text-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.showModal('DISTRIBUTER')))
                          }, "Change")
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            id: "ClearD",
                            name: "ClearD",
                            class: "btn btn-primary add text-center btnClear",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.btnClear('DISTRIBUTER')))
                          }, "Clear")
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary add text-center btnDelete",
                              disabled: $setup.deleteDisableFlag,
                              onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.btnDelete()))
                            }, "削除", 8 /* PROPS */, _hoisted_59),
                            _createElementVNode("button", {
                              type: "button",
                              style: {"margin-left":"5%"},
                              class: "btn btn-primary add text-center btnKettei",
                              disabled: $setup.ketteiDisableFlag,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.btnConfirm()))
                            }, "決定", 8 /* PROPS */, _hoisted_60)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("h5", _hoisted_65, _toDisplayString($setup.modalSubject), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.goClose()))
            })
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _withDirectives(_createElementVNode("input", {
                maxlength: "20",
                class: "txt_userid",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.txtUserId) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.txtUserId]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary text-center btn_search",
                onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.goDetailSearch()))
              }, "Search")
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("table", _hoisted_72, [
                  _createElementVNode("tbody", _hoisted_73, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modalBody, (info, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_74, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: info.userId,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.isChecked) = $event)),
                            onChange: ($event: any) => ($setup.chkCheckEvent(info))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_75), [
                            [_vModelRadio, $setup.isChecked]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_76, _toDisplayString(info.userId), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_77, _toDisplayString(info.userName), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_78, _toDisplayString(info.stationCode_id), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("button", {
              type: "button",
              disabled: $setup.isCheckedOK,
              class: "btn",
              "data-bs-dismiss": "modal",
              onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.goOK()))
            }, " OK ", 8 /* PROPS */, _hoisted_80)
          ])
        ])
      ])
    ]),
    _hoisted_81
  ]))
}